import { FC } from 'react';
import { DownloadLink } from 'molecules/DownloadLink';
import { DownloadLinkItem } from 'molecules/DownloadLink/type';
import styles from './styles.module.css';

export const ItemList: FC<{
  products: DownloadLinkItem[];
}> = ({ products }) => {
  return (
    <ul className={styles.itemList}>
      {products.map(({ href, name, refKey }) =>
        href ? (
          <li key={`${href}-${refKey}`} className={styles.item}>
            <DownloadLink name={name} href={href} refKey={refKey} />
          </li>
        ) : null,
      )}
    </ul>
  );
};
